/* ============================================================
   SPS — Santo Performance Studio · V2
   Local Mockup Script
   ============================================================ */

(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════
     NEXT-CLASS COUNTDOWN  (lives in the nav header)
     ─────────────────────────────────────────────────────────
     CLASS_SCHEDULE is a weekly, recurring timetable. The timer
     finds the next upcoming slot from "now", counts down to it,
     and rolls to the following slot when it hits zero.

     TO REPROGRAM LATER:
       • Edit the entries below, or
       • Replace getNextClass() with a fetch() to your booking
         API / Shopify metafield and return { date, name }.

     day:  0=Sun 1=Mon 2=Tue 3=Wed 4=Thu 5=Fri 6=Sat
     time: 24h "HH:MM" (studio local time)
  ════════════════════════════════════════════════════════ */
  let CLASS_SCHEDULE = [
    // 11 weekly jiu-jitsu classes — matches the displayed schedule + hero stat.
    { day: 1, time: '07:00', name: 'Adults (Gi)' },
    { day: 1, time: '17:00', name: 'Kids (Gi)' },
    { day: 1, time: '18:00', name: 'Adults (Gi)' },
    { day: 2, time: '18:00', name: 'Adults (No-Gi)' },
    { day: 3, time: '07:00', name: 'Adults (No-Gi)' },
    { day: 3, time: '17:00', name: 'Kids (No-Gi)' },
    { day: 3, time: '18:00', name: 'Adults (Gi)' },
    { day: 4, time: '18:00', name: 'Adults (No-Gi)' },
    { day: 5, time: '07:00', name: 'Adults (Gi)' },
    { day: 5, time: '17:00', name: 'Kids (Gi)' },
    { day: 5, time: '18:00', name: 'Adults (Gi)' }
  ];

  // Shopify: the header section can pass an edited schedule as JSON via
  // #nav-countdown[data-schedule]. Falls back to the default above.
  (function () {
    const el = document.getElementById('nav-countdown');
    if (el && el.dataset.schedule) {
      try {
        const parsed = JSON.parse(el.dataset.schedule);
        if (Array.isArray(parsed) && parsed.length) CLASS_SCHEDULE = parsed;
      } catch (e) { /* keep default schedule */ }
    }
  })();

  // Returns the next upcoming class as { date: Date, name: string }.
  function getNextClass(from) {
    const now = from || new Date();
    let best = null;

    // Search the next 8 days to guarantee a hit even across week wrap.
    for (let offset = 0; offset < 8 && !best; offset++) {
      const day = new Date(now);
      day.setDate(now.getDate() + offset);
      const dow = day.getDay();

      CLASS_SCHEDULE
        .filter((c) => c.day === dow)
        .forEach((c) => {
          const [h, m] = c.time.split(':').map(Number);
          const slot = new Date(day);
          slot.setHours(h, m, 0, 0);
          if (slot > now && (!best || slot < best.date)) {
            best = { date: slot, name: c.name };
          }
        });
    }
    return best;
  }

  const countdownEls = document.querySelectorAll('[data-countdown]');
  const nameEls      = document.querySelectorAll('[data-class-name]');
  const navCountdown = document.getElementById('nav-countdown');

  if (countdownEls.length) {
    let current = getNextClass();

    const pad = (n) => String(n).padStart(2, '0');

    function render() {
      if (!current) {
        current = getNextClass(new Date());
        if (!current) return;
      }

      const diff = current.date.getTime() - Date.now();

      // Class has started → advance to the following slot.
      if (diff <= 0) {
        // brief "LIVE NOW" flash before rolling forward
        countdownEls.forEach((el) => (el.textContent = 'LIVE NOW'));
        if (navCountdown) navCountdown.classList.add('is-live');
        current = getNextClass(new Date(Date.now() + 60000));
        return;
      }

      if (navCountdown) navCountdown.classList.remove('is-live');

      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      const text = d > 0
        ? `${d}d ${pad(h)}:${pad(m)}:${pad(s)}`
        : `${pad(h)}:${pad(m)}:${pad(s)}`;

      countdownEls.forEach((el) => (el.textContent = text));
      nameEls.forEach((el) => (el.textContent = current.name));
    }

    render();
    setInterval(render, 1000);
  }

  /* ── Sticky Nav ─────────────────────────────────────────── */
  const nav = document.querySelector('.nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Overlay Menu ───────────────────────────────────────── */
  const menuBtn  = document.querySelector('.nav__menu-btn');
  const overlay  = document.querySelector('.nav-overlay');
  const closeBtn = document.querySelector('.nav-overlay__close');

  function openMenu() {
    overlay.classList.add('is-open');
    menuBtn.classList.add('is-active');
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    overlay.setAttribute('aria-hidden', 'false');
  }
  function closeMenu() {
    overlay.classList.remove('is-open');
    menuBtn.classList.remove('is-active');
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    overlay.setAttribute('aria-hidden', 'true');
  }
  if (menuBtn && overlay) {
    menuBtn.addEventListener('click', () => {
 if (overlay.classList.contains('is-open')) { closeMenu(); }
 else { openMenu(); }
});
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeMenu();
    });
    overlay.querySelectorAll('.nav-overlay__link').forEach((link) =>
      link.addEventListener('click', closeMenu)
    );
  }

  /* ── Hero background entrance ────────────────────────────── */
  const heroBg = document.querySelector('.hero__bg');
  if (heroBg) {
    requestAnimationFrame(() => setTimeout(() => heroBg.classList.add('is-loaded'), 100));
  }

  /* ── Scroll animations ──────────────────────────────────── */
  const animatedEls = document.querySelectorAll('[data-animate]');
  if (animatedEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    animatedEls.forEach((el) => observer.observe(el));
  } else {
    animatedEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ── Smooth anchor scroll ───────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const id = anchor.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      const navH = nav ? nav.offsetHeight : 84;
      const top  = target.getBoundingClientRect().top + window.scrollY - navH;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  /* ── Light parallax on hero ─────────────────────────────── */
  if (heroBg) {
    window.addEventListener('scroll', () => {
      heroBg.style.transform = `scale(1) translateY(${window.scrollY * 0.3}px)`;
    }, { passive: true });
  }

  /* ── Forms ──────────────────────────────────────────────────
     On Shopify the trainer form is a native {% form 'contact' %} and
     the newsletter is {% form 'customer' %}; both post to the server
     and the success/error states are rendered server-side via
     form.posted_successfully? — so no client-side submit handling is
     needed or wanted here (it would block the real submission).
  ──────────────────────────────────────────────────────────── */

})();
